import { borderRadius, typographyV2 } from '@toggle/design-system';
import styled, { css } from 'styled-components';

export const EarningsInsightWrapper = styled.div<{
  $isPreview: boolean;
  $isClickable: boolean;
  $isRead: boolean;
}>`
  width: fit-content;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  ${borderRadius.r2};
  background-color: ${({ $isPreview, $isRead }) =>
    $isRead
      ? 'var(--surface-default)'
      : $isPreview
      ? 'var(--surface-decorative-purple-default)'
      : 'var(--surface-decorative-teal-default)'};
  ${({ $isClickable }) =>
    $isClickable &&
    css`
      &:hover {
        transform: scale(1.05);
        cursor: pointer !important;
      }
    `}
`;

export const EarningsInsightLabel = styled.span<{
  $isPreview: boolean;
  $isRead: boolean;
}>`
  ${typographyV2.uiXs};
  font-family: var(--font-nort);
  color: ${({ $isPreview, $isRead }) =>
    $isRead
      ? 'var(--text-soft)'
      : $isPreview
      ? 'var(--text-decorative-purple)'
      : 'var(--text-decorative-teal)'};
`;
